import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { deleteInArray, errorCatch, GET, GETWITH, JSXMap, Model, POST, QueryDetail, QueryOrder, QueryParam, updateInArray, useAuth, useTranslateContext } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import MDEditor, { } from "@uiw/react-md-editor";
import YImage from '../../../common/YImage';
import { DiffOutlined, DownOutlined, ExclamationCircleOutlined, IssuesCloseOutlined, LoadingOutlined, RightOutlined } from '@ant-design/icons';
import React, { useCallback, useDeferredValue, useEffect, useState } from 'react';
import { BoolCell, FloatCell } from '../../components/EventsByIDBlock';
import Account from '../../components/Account';
import { UserName } from '../../../common/User';
import { Input, Spin } from 'antd';
import { Modal } from 'antd';
import { Tooltip } from 'antd';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

function Element(props) {
    const { item, idx } = props;
    const classes = useStyles();
    const [collapsed, setCollapsed] = useState(true);
    return (
        <div key={item.ID || idx} style={{ width: "100%", padding: "0 5px" }} onClick={() => setCollapsed(o => !o)}>
            <div className={classes.item} style={{ gap: "5px", marginTop: "5px" }}>
                <div style={{ fontSize: "11px", marginTop: "4px" }}>
                    {collapsed == false && <DownOutlined />}
                    {collapsed == true && <RightOutlined />}
                </div>
                <div>
                    <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        <div>{dayjs(item?.dataNachala).format("DD.MM.YYYY")} - {dayjs(item?.dataOkonchaniya).format("DD.MM.YYYY")}</div>
                        {collapsed == true && <div style={{ color: "#7c7c7c", fontWeight: "400", fontSize: "12px" }}>
                            Мероприятий: {item?.meropriyatiya?.length}
                        </div>}
                    </div>
                    {collapsed == false && <div>
                        {JSXMap(item?.meropriyatiya, (x, idx) => (<div>
                            {x?.meropriyatie && <div key={x.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>
                                <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                    <YImage item={x?.meropriyatie} width={32} hidePreview={true} />
                                </div>
                                <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                    <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                        <span style={{ fontWeight: "600" }}>{x?.meropriyatie?.nazvanieMeropriyatiya}</span>
                                    </div>
                                    <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                        <span style={{
                                            marginRight: "5px",
                                            borderRadius: "5px",
                                            backgroundColor: (dayjs().isAfter(x?.meropriyatie?.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                            color: (dayjs().isAfter(x?.meropriyatie?.okonchanieSorevnovaniya)) ? "black" : "white",
                                            fontWeight: (dayjs().isAfter(x?.meropriyatie?.okonchanieSorevnovaniya)) ? "400" : "600",
                                            fontSize: "12px",
                                            boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                            padding: "2px 4px"
                                        }}>{dayjs(x?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                        <span>{x?.meropriyatie?.mestoProvedeniya?.name}</span>
                                    </div>
                                </div>
                            </div>}
                        </div>))}
                    </div>}
                </div>
            </div>
        </div>
    )
}

const StringValueCell = (props) => {
    const auth = useAuth();
    const t = useTranslateContext();

    const { item, value: initialValue, onChange, style, className } = props;

    const [value, setValue] = React.useState(initialValue);
    const [lastError, setLastError] = React.useState();

    const onError = (e) => {
        if (initialValue != value) {
            setLastError(e);
        }
    };
    const onEnter = () => {
        onChange(value, onError);
    };
    const onBlur = () => {
        if (initialValue != value) {
            onChange(value, onError);
        }
    };
    React.useEffect(() => {
        setLastError(undefined);
    }, [value]);
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    let fixed = item?.document?.fixed;
    // let colorClass = (fixed) ?
    //     (!item?.kommentarii) ? `bg-blue border-darkgreen` : `bg-grey border-darkgreen` :
    //     (!item?.kommentarii) ? `bg-blue border-blue` : `bg-grey border-blue`;
    let colorClass = (fixed) ? `bg-grey border-darkgreen`: `bg-blue border-blue`
    const stateClass = () => {
        if (initialValue != value) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    };
    if (!fixed) {
        return (
            <div style={{ height: "100%", ...style }} onClick={(e) => { e.preventDefault() }}>
                <div style={{ height: "100%", position: "relative" }}>
                    <Input
                        key={item.ID}
                        className={`bg ${colorClass} pointer ${stateClass()}`}
                        value={value}
                        onChange={v => {
                            setValue(v.target.value);
                        }}
                        placeholder=""
                        style={{ height: "100%", fontSize: "12px", textAlign: "left", cursor: "pointer", padding: "0px 5px" }}
                        onBlurCapture={onBlur}
                        onPressEnter={onEnter}
                    />
                    {lastError && <div style={{
                        position: "absolute",
                        top: "2px",
                        left: "3px",
                        fontSize: "14px"
                    }}>
                        {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}><Icofont icon="exclamation" style={{ color: "red" }} /></Tooltip>}
                    </div>}
                </div>
            </div>
        )
    }
    return (<div key={item.ID} className={`bg ${colorClass} dark-1`} style={style}>{item?.kommentarii}</div>);
};

function AkkauntRow({ item, idx, account, update, setLoading }) {
    const auth = useAuth()

    const getOstatok = (acc) => {
        if (acc.ostatok >= 0) {
            return (<span style={{ color: "rgb(63, 134, 0)" }}>
                + {Math.abs(Number(acc.ostatok.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
            </span>)
        }
        if (acc.ostatok < 0) {
            return (<span style={{ color: "red" }}>
                - {Math.abs(Number(acc.ostatok.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
            </span>)
        }
    }

    return (<React.Fragment key={idx + "wrap"}>
        <tr key={idx}>

            <td className={`fixed height-5`} style={{ minWidth: "230px", maxWidth: "230px", backgroundColor: "white" }}>
                <div className='bg bg-grey'>
                    <UserName item={item?.akkauntPolzovatelyaNakopitelnii.polzovatel} noborder={true} />
                    <div style={{ fontStyle: "italic", textAlign: "left", marginLeft: "20px", fontSize: "11px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>№{item?.akkauntPolzovatelyaNakopitelnii.akkaunt?.nomerAkkaunta}</div>
                            <div style={{ textAlign: "right" }}>{getOstatok(item?.akkauntPolzovatelyaNakopitelnii.akkaunt)}</div>
                        </div>
                    </div>
                </div></td>
            <td className={`height-5`} style={{ minWidth: "120px", maxWidth: "120px" }}>
                <div className='bg bg-grey'>
                    {(Number(item?.summaNaNachaloPerioda?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                </div>
            </td>
            <td className={`height-5`} style={{ minWidth: "120px", maxWidth: "120px" }}>
                <div className='bg bg-grey'>
                    {(Number(item?.prikhodiZaPeriod?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                </div>
            </td>
            <td className={`height-5`} style={{ minWidth: "120px", maxWidth: "120px" }}>
                <div className='bg bg-grey'>
                    {(Number(item?.ukhodiZaPeriod?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                </div>
            </td>
            <td className={`height-5`} style={{ minWidth: "120px", maxWidth: "120px" }}>
                <div className='bg bg-grey'>
                    {(Number(item?.summaNaKonetsPerioda?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                </div>
            </td>
            <td className="height-5" style={{ minWidth: "45px", backgroundColor: "white" }}>
                <BoolCell
                    disabled={item?.document.fixed}
                    colorClass={(!item?.document.fixed) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.aktivno}
                    onChange={(val, onError) => {
                        setLoading(true);
                        POST(auth, `/api/fed/admin/perevodinakopitelnikhupdate`, { ...item, aktivno: val },
                            ({ data }) => {
                                update(data)
                                setLoading(false);
                            }, (err) => errorCatch(err, () => {
                                onError(err);
                                setLoading(false);
                            }))
                    }}
                />
            </td>
            <td className="height-5" style={{ minWidth: "120px", backgroundColor: "white" }}>
                <FloatCell
                    disabled={item?.document.fixed}
                    colorClass={(!item?.document.fixed) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.protsentNaTekushchiiSchet}
                    min={0}
                    max={100}
                    step={0.01}
                    onChange={(val, onError) => {
                        setLoading(true);
                        POST(auth, `/api/fed/admin/perevodinakopitelnikhupdate`, { ...item, protsentNaTekushchiiSchet: val },
                            ({ data }) => {
                                update(data)
                                setLoading(false);
                            }, (err) => errorCatch(err, () => {
                                onError(err);
                                setLoading(false);
                            }))
                    }}
                />
            </td>
            {JSXMap(account?.meropriyatiya, (x, idx) => (<td key={idx} className={`height-5`} style={{ minWidth: "150px", maxWidth: "150px" }}>
                {x?.meropriyatie && <div key={x.ID} className='bg bg-grey'>
                    {JSXMap(item?.meropriyatiya?.filter(e => e?.meropriyatieID == x?.meropriyatieID), (el, elidx) => (
                        <div key={elidx}>
                            <Tooltip title={<div>
                                {el?.uchastnik == true && <div>Уч - участник</div>}
                                {el?.sudya == true && <div>Су - судья (если судил)</div>}
                                {el?.vedushchii == true && <div>Ве - ведущий</div>}
                                {el?.spetsgost == true && <div>Сг - спецгость</div>}
                                {el?.glavniiSudya == true && <div>Гс - главный судья (если судил)</div>}
                                {el?.didzhei == true && <div>Dj - диджей</div>}
                                {el?.pryamoiEfir == true && <div>Пэ - прямой эфир</div>}
                                {el?.admin == true && <div>Ад - админ</div>}
                                {el?.kontroler == true && <div>Кр - контролер</div>}
                            </div>}>
                                {el?.uchastnik == true && <span>Уч</span>}
                                {el?.sudya == true && <span>Су</span>}
                                {el?.vedushchii == true && <span>Ве</span>}
                                {el?.spetsgost == true && <span>Сг</span>}
                                {el?.glavniiSudya == true && <span>Гс</span>}
                                {el?.didzhei == true && <span>Dj</span>}
                                {el?.pryamoiEfir == true && <span>Пэ</span>}
                                {el?.admin == true && <span>Ад</span>}
                                {el?.kontroler == true && <span>Кр</span>}
                            </Tooltip>
                        </div>
                    ))}
                </div>}
            </td>))}
            <td className="height-5" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }}>
                <StringValueCell item={item} value={item?.kommentarii} style={{ height: "100%", textAlign: "left" }}
                    onChange={(val, onError) => {
                        setLoading(true);
                        POST(auth, `/api/fed/admin/perevodinakopitelnikhupdate`, { ...item, kommentarii: val },
                            ({ data }) => {
                                update(data)
                                setLoading(false);
                            }, (err) => errorCatch(err, () => {
                                onError(err);
                                setLoading(false);
                            }))
                    }} />
            </td>
        </tr>
    </React.Fragment >)
}


function SavingAccountsData(props) {
    const { auth, object } = props;

    const [loading, setLoading] = useState(false);
    const [akkauntData, setAkkauntData] = useState();

    function request() {
        setLoading(true);
        GETWITH(auth, `/api/fed/admin/periodnakopitelnikhperevodovbyid/${object?.ID}`, [
            // QueryParam("akkaunt", object?.ID),
            // QueryParam("datestart", defStart.format('YYYY-MM-DD')),
            // QueryParam("dateend", defEnd.format('YYYY-MM-DD'))
        ], ({ data }) => {
            if (data?.length > 0) {
                setAkkauntData(data[0]);
                setLoading(false);
                // console.log(data[0]);
            }
        }, (err) => errorCatch(err, () => {
            setLoading(false);
        }));
    }

    useEffect(() => {
        request()
    }, [])

    const reinit = useCallback(() => {
        Modal.confirm({
            title: `Обновить`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите обновить все значения в таблице в соответствии с базой данных?</div>
                <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "12px", fontWeight: "lighter" }}>Если в таблице есть не сохраненные изменения, то они будут утеряны.</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                request()
            },
        });
    }, [object])
    const createdocuments = useCallback(() => {
        setLoading(true)
        GET(auth, `/api/fed/admin/perevodinakopitelnikhfixed/${object?.ID}`, ({ data }) => {
            request()
            setLoading(false)
        }, (err) => errorCatch(err, () => setLoading(false)))
    }, [object])

    function update(item) {
        setAkkauntData(o => ({ ...o, perevodiNakopitelnikhSsilkaNaPeriod: updateInArray(o?.perevodiNakopitelnikhSsilkaNaPeriod, item) }))
    }

    return (
        <>
            {props.subheader}
            {/* <div style={{ paddingBottom: "15px", display: "flex", justifyContent: "right" }}>
                <RangePicker
                    locale={locale}
                    format="YYYY-MM-DD"
                    defaultValue={[defStart, defEnd]}
                    onChange={(value) => {
                        GETWITH(auth, `/api/akkaunti/ostatki-po-operatsiyam${(location)?"/"+location:""}`, [
                            QueryParam("akkaunt", object?.ID),
                            QueryParam("datestart", value[0].format('YYYY-MM-DD')),
                            QueryParam("dateend", value[1].format('YYYY-MM-DD'))
                        ], ({ data }) => {
                            setAkkauntOstatki(data);
                        }, errorCatch);
                    }}
                />
            </div> */}
            <Spin spinning={loading} tip="Загрузка...">
                <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Создание документов">
                            <div className={`bg bg-grey pointer`} onClick={() => createdocuments()} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <DiffOutlined style={{ color: "green" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Обновить значения">
                            <div className={`bg bg-grey pointer`} onClick={() => reinit()} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <IssuesCloseOutlined />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                </div>
                {object && <div className='scrollable'>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                {/* <th className={`height-12`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th> */}
                                <th className={`fixed height-8`} style={{ minWidth: "230px", maxWidth: "230px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1'>
                                        <div>Пользователь</div>
                                        <div style={{ fontStyle: "italic" }}>Накопительный счет</div>
                                    </div></th>
                                <th className={`height-8`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма на начало периода</div></th>
                                <th className={`height-8`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Приходы за период</div></th>
                                <th className={`height-8`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Уходы за период</div></th>
                                <th className={`height-8`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма на конец периода</div></th>
                                <th className={`height-8`} style={{ minWidth: "45px", maxWidth: "120px", fontWeight: "300" }}><div className='bg bg-blue dark-1'>Активно</div></th>
                                <th className={`height-8`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-blue dark-1'>Процент на текущий счёт</div></th>
                                {JSXMap(object?.meropriyatiya, (x, idx) => (<th key={idx} className={`height-8`} style={{ minWidth: "150px", maxWidth: "150px" }}>
                                    {x?.meropriyatie && <div key={x.ID} className='bg bg-grey dark-1'>
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <div style={{ flex: "0 0 32px", width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                <YImage item={x?.meropriyatie} width={32} hidePreview={true} />
                                            </div>
                                            <div key="q3" style={{ flex: "1 1 auto", textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                <div style={{
                                                    borderRadius: "5px",
                                                    backgroundColor: (dayjs().isAfter(x?.meropriyatie?.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                    color: (dayjs().isAfter(x?.meropriyatie?.okonchanieSorevnovaniya)) ? "black" : "white",
                                                    fontWeight: (dayjs().isAfter(x?.meropriyatie?.okonchanieSorevnovaniya)) ? "400" : "600",
                                                    fontSize: "12px",
                                                    boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                    padding: "2px 4px"
                                                }}>{dayjs(x?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</div>
                                                <div style={{ fontSize: "11px", textAlign: "left", margin: "3px 0 0 3px" }}>{x?.meropriyatie?.mestoProvedeniya?.name}</div>
                                            </div>
                                        </div>
                                        <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "5px", fontSize: "11px", textAlign: "left" }}>
                                            <span style={{ fontWeight: "400" }}>{x?.meropriyatie?.nazvanieMeropriyatiya}</span>
                                        </div>
                                    </div>}
                                </th>))}
                                <th className={`height-8`} style={{ minWidth: "200px", fontWeight: "300" }}><div className="bg bg-blue dark-1">Комментарий</div></th>
                            </tr>
                            {/* <tr className="tr-rounded">
                            <th></th>
                            <th className={`wrap`}><div className="bg bg-blue"><div style={{
                                fontStyle: "italic",
                                color: "rgba(0, 0, 0, 0.45)",
                            }}>№{akkauntOstatki?.nomerAkkaunta}</div></div></th>
                            <th className={`wrap`}><div className="bg bg-blue"></div></th>
                            <th className={`wrap`}><div className="bg bg-blue">{getCurrencyValue(summaOperatsiy)}</div></th>
                            <th className={`wrap`}><div className="bg bg-blue"></div></th>
                        </tr> */}
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(akkauntData?.perevodiNakopitelnikhSsilkaNaPeriod, (o, oidx) => {
                                return (<AkkauntRow key={oidx} idx={oidx} item={o} account={akkauntData} update={update} setLoading={setLoading} />)
                            })}
                        </tbody>
                    </table>
                </div>}
            </Spin>
        </>
    );
}

export default function FederationadministratorManagementSavingsaccount(props) {
    const classes = useStyles();
    const { auth } = props;

    const filters = () => [
        {
            label: "Номер",
            name: "ID",
            sort: true,
            filter: true,
        },
        {
            label: "Дата начала",
            name: "dataNachala",
            sort: true,
            filter: true,
        },
        {
            label: "Дата окончания",
            name: "dataOkonchaniya.",
            sort: true,
            filter: true,
        },
    ];

    const uiFilterDialogMeropriyatie = () => [
        {
            label: "Дата начала",
            name: "nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
            sorted: "DESC",
            filtered: [dayjs().subtract(1, "years"), dayjs().add(10, "days")],
        },
        {   // Тип мероприятия
            label: "Тип мероприятия",
            name: "tipMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Уровень мероприятия
            label: "Уровень мероприятия",
            name: "urovenMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Место проведения
            label: "Место проведения",
            name: "mestoProvedeniya",
            filterType: "group",
            display: (o) => o.name,
            sort: true,
            filter: true
        },
    ]
    const displayStringDialogMeropriyatie = (item) => {
        return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
    }
    const displayDialogMeropriyatie = (item) => {
        return (
            <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>
                <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                    <YImage item={item} width={32} hidePreview={true} />
                </div>
                <div style={{ flex: "auto", paddingLeft: "7px" }}>
                    <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                        <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                    </div>
                    <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                        <span style={{
                            marginRight: "5px",
                            borderRadius: "5px",
                            backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                            color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                            fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",
                            fontSize: "12px",
                            boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                            padding: "2px 4px"
                        }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                        <span>{item?.mestoProvedeniya?.name}</span>
                    </div>
                </div>
            </div>
        )
    }

    const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => {
        return (<Element item={item} idx={idx}></Element>)
    }

    // POST  /api/fed/admin/perevodinakopitelnikhbuild
    // GET   /api/fed/admin/perevodinakopitelnikhclear/{id}
    // GET   /api/fed/admin/periodnakopitelnikhperevodovbyid/{id}
    // GET   /api/fed/admin/periodnakopitelnikhperevodovlist
    // POST  /api/fed/admin/perevodinakopitelnikhupdate

    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingBottom: "15px", fontSize: "18px" }}>Рассчеты по накопительным счетам</div>
                </div>
                <CollectionServer
                    auth={auth}
                    name={"PeriodNakopitelnikhPerevodov"}
                    // queryDetail={"collection"}
                    source={"/api/fed/admin/periodnakopitelnikhperevodovlist"}
                    filters={filters}
                    size={"small"}
                    mode={"list"}
                    // title="Рассчеты по накопительным счетам"
                    render={render}

                    collectionActions={() => [
                        {
                            auth: auth,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POST(auth, `/api/fed/admin/perevodinakopitelnikhbuild`, { ...values, meropriyatiya: values?.meropriyatiya?.map(e => ({ meropriyatieID: e?.ID })) },
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data, true));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            title: "Создать рассчет",
                            modal: {
                                title: "Создание рассчета по накопительным счетам",
                                width: "650px"
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Дата начала",
                                    name: "dataNachala",
                                    type: "date",
                                },
                                {
                                    label: "Дата окончания",
                                    name: "dataOkonchaniya",
                                    type: "date",
                                },
                                {
                                    label: "Мероприятия",
                                    name: "meropriyatiya",
                                    type: "collection", //"object",

                                    // mode: "dialog",
                                    validators: { required: true },
                                    modal: { width: "700px" },
                                    relation: {
                                        uiFilter: uiFilterDialogMeropriyatie,
                                        display: displayDialogMeropriyatie,
                                        displayString: displayStringDialogMeropriyatie,
                                        reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                        type: "many-one",
                                        // type: "one-many",
                                    },
                                    queryFilter: [
                                        QueryParam("w-eq-isPublic", "true"),
                                        QueryDetail("model"),
                                        QueryOrder("nachaloSorevnovaniya", "DESC")
                                    ]
                                    // dropdownActions: () => [
                                    //     {
                                    //         title: "Создать категорию",
                                    //         form: Model,
                                    //         meta: [
                                    //             {
                                    //                 label: "Название",
                                    //                 name: "nazvanie",
                                    //                 type: "string",
                                    //             },
                                    //             {
                                    //                 label: "Описание",
                                    //                 name: "opisanie",
                                    //                 type: "string",
                                    //             },
                                    //         ],
                                    //         action: (values, unlock, close, { collection, setCollection, apply }) => {
                                    //             POST(auth, '/api/kategoriya-novostei/create', { ...values },
                                    //                 ({ data }) => {
                                    //                     setCollection(updateInArray(collection, data));
                                    //                     if (apply) {
                                    //                         apply(data);
                                    //                     }
                                    //                     close();
                                    //                 },
                                    //                 (err) => errorCatch(err, unlock)
                                    //             );
                                    //         },
                                    //     },
                                    // ]
                                },
                            ],
                        }]}
                    modelActions={(item) => {
                        return [
                            {
                                title: "Данные по накопительным счетам",
                                readonly: true,
                                noAntForm: true,
                                titles: {
                                    subheader: <div style={{ paddingBottom: "15px" }}>
                                        <Element item={item}></Element>

                                        {/* <div>№{item?.nomerAkkaunta} </div>
                                        <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                            {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                        </div> */}
                                    </div>
                                },
                                modal: {
                                    width: "90%",
                                },
                                object: item,
                                form: SavingAccountsData,
                                action: (values, unlock, close, { collection, setCollection }) => { },
                            },
                            // {
                            //     auth: auth,
                            //     action: (values, unlock, close, { collection, setCollection }) => {
                            //         POST(auth, `/api/novosti/update`, { ...values, ID: item?.ID },
                            //             ({ data }) => {
                            //                 setCollection(updateInArray(collection, data, true));
                            //                 close();
                            //             }, (err) => errorCatch(err, unlock)
                            //         );
                            //     },
                            //     title: "Изменить рассчет",
                            //     modal: {
                            //         title: "Изменение рассчета",
                            //         width: "650px"
                            //     },
                            //     form: Model,
                            //     meta: [
                            //         {
                            //             label: "Категория",
                            //             name: "kategoriya",
                            //             type: "object",
                            //             relation: {
                            //                 display: (item) => {
                            //                     return item.nazvanie
                            //                 },
                            //                 reference: { object: "KategoriyaNovostei", property: "ID" },
                            //                 type: "many-one",
                            //             },
                            //             queryFilter: [
                            //                 QueryDetail("model"),
                            //                 QueryOrder("nazvanie", "ASC")
                            //             ],
                            //             dropdownActions: () => [
                            //                 {
                            //                     title: "Создать категорию",
                            //                     form: Model,
                            //                     meta: [
                            //                         {
                            //                             label: "Название",
                            //                             name: "nazvanie",
                            //                             type: "string",
                            //                         },
                            //                         {
                            //                             label: "Описание",
                            //                             name: "opisanie",
                            //                             type: "string",
                            //                         },
                            //                     ],
                            //                     action: (values, unlock, close, { collection, setCollection, apply }) => {
                            //                         POST(auth, '/api/kategoriya-novostei/create', { ...values },
                            //                             ({ data }) => {
                            //                                 setCollection(updateInArray(collection, data));
                            //                                 if (apply) {
                            //                                     apply(data);
                            //                                 }
                            //                                 close();
                            //                             },
                            //                             (err) => errorCatch(err, unlock)
                            //                         );
                            //                     },
                            //                 },
                            //             ]
                            //         },
                            //         {
                            //             label: "Опубликована",
                            //             name: "opublikovana",
                            //             type: "bool",
                            //         },
                            //         {
                            //             label: "Дата рассчета",
                            //             name: "dataNovosti",
                            //             type: "date",
                            //         },
                            //         {
                            //             label: "Заголовок",
                            //             name: "zagolovok",
                            //             type: "string",
                            //         },
                            //         {
                            //             label: "Ссылка на ресурс",
                            //             name: "ssilkaNaResurs",
                            //             type: "string",
                            //         },
                            //     ],
                            // },
                            {
                                auth: auth,
                                title: <span style={{ color: "red" }}>Удалить</span>,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    confirmKey({
                                        pass: '123',
                                        title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить рассчет</span>,
                                        icon: undefined,
                                        content: <div>
                                            <div>Вы действительно хотите удалить рассчет?</div>
                                            <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.zagolovok} </div>
                                        </div>,
                                        okText: 'Удалить',
                                        cancelText: 'Отмена',
                                        onOk() {
                                            return new Promise((resolve, reject) => {
                                                GET(auth, '/api/fed/admin/perevodinakopitelnikhclear/' + item.ID,
                                                    ({ data }) => {
                                                        setCollection(deleteInArray(collection, item));
                                                        resolve(data);
                                                    }, (err) => errorCatch(err, reject));
                                            }).catch(() => { });
                                        },
                                        onCancel() {
                                        },
                                    })
                                }
                            }
                        ]
                    }}
                />
            </div>
        </PageLayout>
    );
}
